import { CurrencyApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeCurrencies } from './normalizers';
import { Currency } from './types';

export class VoladeumCurrencies extends Axios {
  async list(): Promise<VoladeumResponse<Currency[]>> {
    const res = await this.get<VoladeumResponse<CurrencyApi[]>>('/v1/currencies');
    return {
      success: res.success,
      error: res.error,
      data: normalizeCurrencies(res.data),
    };
  }
}
